import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { AuthenticationService } from '../services/auth.service';
import { ServerStatusService } from '../services/server-status.service';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private serverStatusService: ServerStatusService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    this.serverStatusService.setConnectionLost(false);
                }
            }),
            catchError(err => {
                const isServerDown = err?.status === 0 || err?.status === 502 || err?.status === 503 || err?.status === 504;
                this.serverStatusService.setConnectionLost(isServerDown);

                if (this.shouldAutoLogout(request, err)) {
                    // auto logout only for authenticated API requests, not public assets/uploads
                    this.authenticationService.logout();
                    location.reload();
                }

                const message = err?.error?.message || err?.error?.error || err?.statusText || 'Request failed';
                const description = err?.error?.description || err?.error?.detail || '';

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: message,
                    text: description,
                    showConfirmButton: false,
                    timer: 4500,
                    timerProgressBar: true
                });

                return throwError(() => err);
            })
        );
    }

    private shouldAutoLogout(request: HttpRequest<any>, err: any): boolean {
        if (err?.status !== 401) {
            return false;
        }

        const url = String(request?.url || '').toLowerCase();
        const hasToken = !!this.authenticationService.currentUserToken();

        if (!hasToken) {
            return false;
        }

        if (url.includes('/api/uploads/')) {
            return false;
        }

        return url.includes('/api/') && !url.includes('/api/auth/login');
    }
}
